const ru = {
    "Bütün Kateqoriyalar": "Все категории",
    "Kateqoriyalar": "Категории",
    "Kateqoriya": "Категория",
    "Alətlər": "Инструменты",
    "Elektronika": "Электроника",
    "Nişan & Toy": "Помолвка & Cвадьба",
    "Geyim": "Одежда",
    "Ev & Mətbəx": "Дом & Кухня",
    "Oyuncaqlar & Oyunlar": "Игрушки & игры",
    "İdman malları": "Спорт",
    "Musiqi": "Музыка",
    "DVDS & Video oyunlar": "DVD & Bидеоигры",
    "Qarışıq": "Разное",
    "Çanta": "Сумка",
    "Velosiped": "Велосипед",
    "İdman Geyimi": "Спортивная одежда",
    "5 AZN / həftəlik": "5 AZN / еженедельно",
    "15 AZN / həftəlik": "15 AZN / еженедельно",
    "20 AZN / həftəlik": "20 AZN / еженедельно",
    "ALMA!": "НЕ КУПИТЬ",
    "Məhsulu axtarın..": "Ищите товар..",
    "Məhsulu axtarın": "Ищите товар",
    "İCARƏYƏ GÖTÜR": "АРЕНДОВАТЬ",
    "İcarəyə götür": "Арендовать",
    "İCARƏYƏ VER": "ДОБАВИТЬ",
    "İcarəyə ver": "Разместите предмет",
    "Hamısına Bax": "Увидеть все",
    "Bizi izləyin": "Подписывайтесь на нас",
    "Bütün hüquqlar qorunur": "Все права защищены",
    "Günlük": "Ежедневно",
    "Əsas səhifə": "Домашняя страница",
    "məhsul tapıldı": "продукт найден",
    "Çeşidlə": "Сортировать по",
    "Qiymətə görə (əvvəlcə ucuz)": "Цена (Снизу вверх)",
    "Qiymətə görə (əvvəlcə bahalı)": "Цена (По убыванию)",
    "Hamısı": "Все",
    "Qiymət": "Цена",
    "Filtiri təmizlə": "Очистить фильтры",
    "Yeni elan yerləşdir": "Hовое объявление",
    "Siyahıdan seçin": "Выбрать из списка",
    "Şəhər": "Город",
    "Məzmun": "Описание",
    "simvol qalıb": "символов",
    "Şəkillər": "Изображений",
    "Şəkil əlavə et": "Добавить изображение",
    "Şəkilin ölçüsü 3096kb-dan çox olmamalıdır.": 
    "Размер изображения не должен превышать 3096 Кб.",
    "Əlaqə məlumatları": "Контактная информация",
    "Adınız": "Имя",
    "Mobil nömrə": "мобил",
    "Elanı yerləşdir": "Разместите объявление",
    "Bağışlayın, seçdiyiniz kriteriya üzrə heç bir məhsul tapılmadı": 
    "Извините, по выбранным вами критериям результатов не найдено",
    "Ətraflı Bax": "Смотрите подробности",
    "Axtar": "Поиск",
    "İcarə": "Арендовать",
    "Satış": "Купить",
    "Həftəlik": "Еженедельно",
    "Məsul şəxs": "Контактное лицо",
    "Mobil": "Номер мобильного",
    "İcarə qiyməti": "Стоимость аренды",
    "Satış qiyməti": "Цена продажи",    
};

export default ru;